import { Component, EventEmitter, Output, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ButtonModule } from 'primeng/button';

export interface FooterNavItem {
    path: string;
    label: string;
    exact?: boolean;
}
@Component({
    selector: 'pax-footer',
    standalone: true,
    imports: [ButtonModule, RouterLink, RouterLinkActive],
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
    readonly availableLanguages = input.required<string[]>();
    readonly logoUrl = input<string>('/assets/logo.svg');
    readonly lang = input.required<string>();
    readonly footerItems = input.required<FooterNavItem[]>();

    @Output() languageChange = new EventEmitter<string>();
}
